import ApiService from '@/services/ApiService';

export default {
  list(locationId) {
    return ApiService().get('/tables/'+locationId);
  },
};
